import React, { Component } from "react";
import { Mycard, Flex, MyCampo, Transition } from "../ui.js";
import {Btn} from "./../UI-Components/Btn";

/** @jsx jsx */
import { jsx, css } from "@emotion/core";
import { serviceApiResponse, parseJwt } from "../ServiciosMaestros/request";
import { api } from "../ServiciosMaestros/apis";
import { handleIntegrationError } from "../ServiciosMaestros/handleIntegrationError";
import AdminPayments from "../adminPayments";
import { Modal2 } from "../ServiciosMaestros/componentGeneral";
import { DescriptionComponent } from '../Helpers/urlDescription'
class Inicio extends Component {
  constructor(props) {
    super(props);
    this.modalRestHorarios = this.modalRestHorarios.bind(this);
  }

  state = {
    loading: false,
    configuracion: [],
    valueSelect: "",
    textSelect: "",
    value1: "",
    value2: null,
    errorSelect: "",
    errorValue1: "",
    errorValue2: "",
    nameSelect: "",
    cruzada:[],
    data: [],
    adminPayments: false,
    adminPaymentConsulta: "",
    suscripcionProyecto: null,
    openModal: false,
    plantilla: {
      titulo: "Ingrese sus datos",
      descripcion: "Consulte sus facturas"
    }
  };
  modalRestHorarios(){
    this.setState({openModal: true})
  }
  componentWillMount() {
    if(!this.props.rest_horarios.activo){
        this.modalRestHorarios();
    }
  }
  componentDidUpdate(prevProps){
    if(prevProps.rest_horarios.activo!== this.props.rest_horarios.activo){
      if(!this.props.rest_horarios.activo){
          this.modalRestHorarios();
      }
    }
  }
  componentDidMount() {
    if (sessionStorage.getItem("configuracion")) {
      let confi = JSON.parse(sessionStorage.getItem("configuracion"));
      if (Object.keys(confi).indexOf("busqueda") !== -1) {
        let filterConf = confi.busqueda.filter((conf) => !conf.cruzada);

        let configuracion = filterConf.map((conf) => {
            return { 
              name: conf.titulo_campo, 
              value: conf.tipo_campo, 
              select: conf.tipo == "select", 
              options: conf.options
            };
        });
        let cruzada = confi.busqueda.filter((conf) => conf.cruzada);
        let valueSelect = "";
        let nameSelect = "";
        let textSelect = "";
        if (configuracion.length > 0 && configuracion.length < 2) {
            valueSelect = configuracion[0].value;
          if(configuracion[0].value === "concepto_pago"){
            nameSelect = configuracion[0].value;
            textSelect = configuracion[0].options[0].name;
          }else{
            nameSelect = configuracion[0].name;
            textSelect = configuracion[0].name;
          }
        }
        let plantilla = {};
        if (Object.keys(confi).indexOf("plantilla") !== -1) {
          plantilla = confi.plantilla;
          
          plantilla.titulo = Object.keys(plantilla).indexOf("titulo") !== -1 ? plantilla.titulo : "Ingrese sus datos";
          plantilla.descripcion = Object.keys(plantilla).indexOf("descripcion") !== -1 ? plantilla.descripcion : "Consulte sus facturas";
        }
        this.setState({
          plantilla,
          configuracion,
          cruzada,
          valueSelect,
          nameSelect,
          textSelect,
          suscripcionProyecto: confi.info.suscripcionProyecto || null,
        });
      }
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (!this.state.suscripcionProyecto && nextProps.suscripcionProyecto) {
      this.setState({ suscripcionProyecto: nextProps.suscripcionProyecto });
    }
    if (Object.keys(nextProps).length > 0 && nextProps.configuracion) {
      let filterConf = nextProps.configuracion.filter((conf) => !conf.cruzada);
      let configuracion = filterConf.map((conf) => {
          return { 
            name: conf.titulo_campo, 
            value: conf.tipo_campo, 
            select: conf.tipo == "select", 
            options: conf.options
          };
      });
      let cruzada = nextProps.configuracion.filter((conf) => conf.cruzada);

      let valueSelect = "";
      if (configuracion.length > 0 && configuracion.length < 2){
        valueSelect = configuracion[0].value;
      }
        
      this.setState({
        configuracion,
        cruzada,
        valueSelect,
      });
    }
  }

  onChangeSelect(e) {
    let value = e.target.value;
    let text = e.target.options[e.target.selectedIndex].innerText;
    this.setState({
      valueSelect: value,
      textSelect: text,
      errorSelect: value !== "" ? "" : this.state.errorSelect,
    });
  }
  onChangeSelectConceptoPago(e) {
    let value = e.target.value;
    let text = e.target.options[e.target.selectedIndex].innerText;
    this.setState({
      valueSelect: this.state.valueSelect,
      value1: value,
      textSelect: text,
      errorSelect: value !== "" ? "" : this.state.errorSelect,
    });
  }
  onChangeInputText(e) {
    let value = e.target.value;
    let name = e.target.name;
    if(name == "cruzada"){
      this.setState({
        value2: value,
        errorValue2: value !== "" ? "" : this.state.errorValue2,
      });
    }else{
      this.setState({
        value1: value,
        errorValue1: value !== "" ? "" : this.state.errorValue1,
      });
    }
  }

  buscarFactura(e) {
    e.preventDefault();
    if (this.state.valueSelect !== "" && this.state.value1 !== "") {
      if(this.state.cruzada.length > 0 && !this.state.value2){
        this.setState({
          errorValue2: `¡El campo ${this.state.cruzada[0].titulo_campo} es obligatorio!`,
        });
        return 0;
      }
      this.setState({
        loading: true,
      });
      sessionStorage.removeItem("isSuscrito");
      sessionStorage.removeItem("parameterSearch");
      sessionStorage.removeItem("total");
      sessionStorage.removeItem("facturas");
      sessionStorage.removeItem("paginacion");
      sessionStorage.removeItem("facturaPagar");
      sessionStorage.removeItem("autoCheckout");


      let data = {
        referencia: this.state.value1,
        band: "r",
        option: this.state.valueSelect,
        option2: this.state.cruzada.length > 0 ? this.state.cruzada[0].tipo_campo : null,
        referencia2: this.state.cruzada.length > 0 ? this.state.value2 : null,
      };
      let informacion = JSON.parse(sessionStorage.getItem("informacion"));
      serviceApiResponse(data, api.facturas, "POST")
        .then((response) => {
          const getTipoMoneda = (moneda) => {
              let tipoMoneda = moneda;
              if(tipoMoneda){
                  tipoMoneda = tipoMoneda ? tipoMoneda.value : 'COP'
              }else{
                  tipoMoneda = 'COP'
              }
              return tipoMoneda ? tipoMoneda : 'COP';
          }
          if (response.success) {
            //console.log("DATA::::", response.data);
            this.setState(
              {
                loading: false,
                data: response.data,
              },
              () => {
                let facturas = response.data.facturas;
                if (facturas.length > 0) {
                  if (facturas.length === 1)
                    sessionStorage.setItem("facturaPagar", 0);
                  sessionStorage.setItem(
                    "facturas",
                    JSON.stringify(response.data.facturas)
                  );
                  sessionStorage.setItem(
                    "configCampos",
                    JSON.stringify(response.data.configCampos)
                  );
                  sessionStorage.setItem(
                    "total",
                    JSON.stringify(response.data.total)
                  );
                  sessionStorage.setItem(
                    "param",
                    JSON.stringify({
                      referencia: this.state.value1,
                      option: this.state.textSelect,
                      optionDb: this.state.valueSelect,
                      optionDb2: this.state.cruzada.length > 0 ? this.state.cruzada[0].tipo_campo : null,
                      referencia2: this.state.cruzada.length > 0 ? this.state.value2 : null,
                    })
                  );
                  if (sessionStorage.getItem("check")) {
                    sessionStorage.removeItem("check");
                    sessionStorage.removeItem("checksOtroValor");
                    sessionStorage.removeItem("checksValor1");
                    sessionStorage.removeItem("checksValor2");
                    sessionStorage.removeItem("checksValor3");
                    sessionStorage.removeItem("valuesOtroValor");
                  }
                  let opcionesRecaudo = response.data.opcionesRecaudo;
                  if (opcionesRecaudo) {
                    sessionStorage.setItem(
                      "opcionesRecaudo",
                      JSON.stringify({
                        ...response.data.opcionesRecaudo, moneda: {
                        value: getTipoMoneda(response.data.opcionesRecaudo.moneda)
                    }})
                    );
                  }
                  if (response.data.parametrosConsultaSuscripcion) {
                    sessionStorage.setItem(
                      "parameterSearch",
                      JSON.stringify(
                        response.data.parametrosConsultaSuscripcion
                      )
                    );
                  }
                  if (response.data.accion) {
                    sessionStorage.setItem(
                      "accionSuscripciones",
                      response.data.accion
                    );
                  }
                  sessionStorage.setItem(
                    "paginacion",
                    JSON.stringify(response.data.paginacionFacturas)
                  );
                  if(response.data.reservarConfig){
                    sessionStorage.setItem(
                      "reservarConfig",
                      JSON.stringify(response.data.reservarConfig)
                    );
  
                  }
                  const ruta = JSON.parse(sessionStorage.getItem("rutas"));
                  if (response.data.facturas.length === 1)
                    this.props.history.push({ pathname: ruta.factura, isSuscrito: response.data.isSuscrito });
                  else
                    this.props.history.push({ pathname: ruta.facturas, isSuscrito: response.data.isSuscrito });
                } else {
                  if (Object.keys(response.data).indexOf("producto") >= 0) {
                    if (!response.data.producto)
                      this.props.openModal(
                        `El servicio se encuentra temporalmente suspendido, lo invitamos a contactar con la ${
                          informacion.nombreEmpresa
                        } para obtener mayor información al (${
                          informacion.tipoTelefonoValue === "fijo"
                            ? informacion.valueIndicativo
                            : informacion.indicativoPais
                        }) ${informacion.tel_empresa} o correo electrónico ${
                          informacion.correo_empresa
                        }.`,
                        "info"
                      );
                    else
                      this.props.openModal(
                        "No cuenta con facturas pendientes por pagar.",
                        "info"
                      );
                  } else {
                    this.props.openModal(
                      "No cuenta con facturas pendientes por pagar.",
                      "info"
                    );
                  }
                }
              }
            );
          } else {
            this.setState({
              loading: false,
            });

            if (Object.keys(response.data).indexOf("producto") >= 0) {
              if (!response.data.producto) {
                this.props.openModal(
                  `El servicio se encuentra temporalmente suspendido, lo invitamos a contactar con la empresa ${
                    informacion.nombreEmpresa
                  } para obtener mayor información al (${
                    informacion.tipoTelefonoValue === "fijo"
                      ? informacion.valueIndicativo
                      : informacion.indicativoPais
                  }) ${informacion.tel_empresa} o correo electrónico ${
                    informacion.correo_empresa
                  }.`,
                  "info"
                );
              }
              else
                this.props.openModal(
                  "Ocurrió un error al consultar la factura, por favor intente más tarde.",
                  "warning"
                );
            } else {
              this.props.openModal(
                "Ocurrió un error al consultar la factura, por favor intente más tarde.",
                "warning"
              );
            }
          }
        })
        .catch((error) => {
          handleIntegrationError(error, {
            openModal: this.props.openModal,
            flow: "consulta",
            service: "recaudo-api",
            endpoint: api.facturas,
            setState: (updates) => this.setState(updates),
            stateUpdates: { loading: false },
            modalType: "warning",
          });
        });
    } else {
      if (this.state.valueSelect === "" && this.state.value1 === "") {
        this.setState({
          errorValue1: `¡Campo requerido!`,
          errorSelect: "¡Debe seleccionar un tipo de dato!",
        });
      } else if (this.state.valueSelect === "") {
        this.setState({
          errorSelect: "¡El campo es obligatorio!",
        });
      } else {
        this.setState({
          errorValue1: `¡El campo ${this.state.nameSelect} es obligatorio!`,
        });
      }
    }
    /* Método para obtener el identificador del cliente */
  }
  getIdentificador() {
    let configuracion = sessionStorage.getItem("configuracion");
    if (configuracion) {
      configuracion = JSON.parse(configuracion);
      return configuracion.info.identificadorSuscripciones
        ? JSON.parse(configuracion.info.identificadorSuscripciones)
        : null;
    }
  }

  async handleScriptLoad() {
    //console.log("AQUI:::::::");
    window.ePayco2.checkout({
      configure: {
        key: parseJwt(),
        test: true,
      },
      createOrder: () => {
        return window.ePayco2.checkout.signature({
          data: {},
        });
      },
      onChangeState: ({ button }) => {
        const { element, isSubscription } = button;
        if (isSubscription) element.textContent = "Administrar suscripción";
      },
      onCloseModal: () => {},
      onFinish: (data) => {},
      selector: "#open-checkout",
    });
  }

  render() {
    return (
      <Flex
        elastic={"0 0 auto"}
        flex={"1 0 auto"}
        className={"wc cambio"}
        css={css`
          animation: ${Transition} 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 1;
        `}
      >
        <Mycard
          className={`col-12 ${this.state.configuracion.length > 2 ? " col-sm-12 col-md-10 col-lg-8 ":  "col-sm-8 col-md-6 col-lg-4" } mx-auto px-0 `}
          title={this.state.plantilla.titulo}
          titleClass="title_consulta"
          tabs={
            this.state.suscripcionProyecto && [
              {
                active: !this.state.adminPayments,
                text: "Ingrese sus datos",
                onClick: () => this.setState({ adminPayments: false }),
              },
              {
                active: this.state.adminPayments,
                text: "Pagos automáticos",
                onClick: () => {
                  this.setState({ adminPayments: true });
                },
              },
            ]
          }
        >
          <div className="wc cg text-center description_consulta">
            <p className={"mb-0 description_consulta"}>{this.state.adminPayments ?
              "Suscriba sus facturas para pagos automáticos":
              <DescriptionComponent text={this.state.plantilla.descripcion}/>
            }</p>
          </div>
          {this.state.adminPayments ? (

            <AdminPayments
              identificador={this.getIdentificador()}
              suscripcionProyectoId={this.state.suscripcionProyecto}
            />
          ) : (
            <form
              className={"col-12"}
              onSubmit={(e) =>{
                let envia = this.buscarFactura.bind(this);
                    e.preventDefault();
                    if(this.state.valueSelect !== ""){
                        if(this.props.rest_horarios.activo){
                          return envia(e);
                        }else{
                            this.modalRestHorarios();
                        }
                    }
              }}
            >
              <div className="col-12 mb-3 py-4  ">
                {
                  this.state.configuracion.length > 1 && (
                    <MyCampo
                      select
                      label={"Seleccione la opción de consulta"}
                      options={this.state.configuracion}
                      value={this.state.valueSelect}
                      onchange={this.onChangeSelect.bind(this)}
                      disabled={this.state.loading}
                      error={this.state.errorSelect}
                    />
                  )
                }
                {
                  this.state.configuracion.length === 1 && this.state.configuracion[0].value === "concepto_pago" ? 
                  (<MyCampo
                    select
                    label={this.state.configuracion[0].name}
                    options={this.state.configuracion[0].options}
                    value={this.state.value1}
                    onchange={this.onChangeSelectConceptoPago.bind(this)}
                    disabled={this.state.loading}
                    error={this.state.errorSelect}
                  />)
                  :
                  (this.state.valueSelect !== "" && (
                    <MyCampo
                      type={"text"}
                      label={
                        this.state.configuracion.length > 0 &&
                        this.state.configuracion.length < 2
                          ? this.state.configuracion.length <= 0
                            ? this.state.textSelect !== "" &&
                              this.state.textSelect !== "Seleccione"
                              ? this.state.textSelect
                              : "Documento"
                            : this.state.configuracion[0].name
                          : this.state.textSelect !== "" &&
                            this.state.textSelect !== "Seleccione"
                          ? this.state.textSelect
                          : "Documento"
                      }
                      className={"pt-3"}
                      value={this.state.value1}
                      onchange={this.onChangeInputText.bind(this)}
                      disabled={this.state.loading}
                      error={this.state.errorValue1}
                    />
                  ))
                }

                {this.state.cruzada.length > 0 && (
                  <MyCampo
                    type={"text"}
                    label={
                      this.state.cruzada[0].titulo_campo
                    }
                    name={"cruzada"}
                    className={"pt-3"}
                    value={this.state.value2}
                    onchange={this.onChangeInputText.bind(this)}
                    disabled={this.state.loading}
                    error={this.state.errorValue2}
                  />
                )}
              </div>

              <div className="col-12 pb-3 line-height-0">
                <Btn
                  loading={this.state.loading}
                  disabled={this.state.loading }
                  type={"submit"}
                >
                  Continuar
                </Btn>
              </div>
            </form>
          )}
        </Mycard>
        <Modal2
          open={this.state.openModal}
          close={() => this.setState({openModal: false})}
          message={this.props.rest_horarios.message}
          message2={this.props.rest_horarios.message2}
          tipo={"info"}
          />
      </Flex>
    );
  }
}

export default Inicio;
